import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FilterIntervalOption } from '../filter.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NumberRangeInputComponent } from '../../number-range-input/number-range-input.component';
import { FilterOptionComponent } from '../../filter-option/filter-option.component';

@Component({
  selector: 'app-filter-humidity',
  templateUrl: './filter-humidity.component.html',
  styleUrls: ['./filter-humidity.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FilterOptionComponent, NumberRangeInputComponent, TranslatePipe],
})
export class FilterHumidityComponent {
  @Input() selectedIntervalOption?: FilterIntervalOption;

  @Output() apply = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() optionChange: EventEmitter<FilterIntervalOption> = new EventEmitter<FilterIntervalOption>();

  onApply() {
    this.apply.emit();
  }

  onBack() {
    this.back.emit();
  }

  onOptionChange(event: FilterIntervalOption) {
    this.optionChange.emit(event);
  }
}
